// 状态类型过滤器
/**************************** 设备 *****************************************/
/***设备状态样式****/
export const statusType = (status) => {
    switch (status) {
        case 1: return 'success';
        case 2: return 'warning';
        case 0: return 'danger';
        default: return 'info';
    }
}



// 状态文本过滤器
export const statusText = (status) => {
    const statusMap = {
        1: '在线',
        0: '离线',
        '-1': '待激活'
    }
    return statusMap[status] || '异常'
}



/********************************* 产品 *******************************************/
// 产品网络类型过滤器
export const productNettype = (status) => {
    const nettyMap = {
        1: '4G',
        2: '以太网',
        3: '485'
    }
    return nettyMap[status] || '异常'
}
//数据格式过滤器
export const productFormat = (status) => {
    const nettyMap = {
        1: 'MQTT',
        2: 'UDP',
        3: 'Modbus'
    }
    return nettyMap[status] || '异常'
}

export const productType = (status) => {
    const nettyMap = {
        1: '网关',
        2: '直联设备',
        3: '子设备'
    }
    return nettyMap[status] || '异常'
}

export const productAuth = (status) => {
    const nettyMap = {
        1: 'SSL',
        2: '其他'
    }
    return nettyMap[status] || '异常'
}
export const productStatus = (status) => {
    const nettyMap = {
        1: '正常',
        2: '异常'
    }
    return nettyMap[status] || '异常'
}

export const customerType = (status) => {
    const nettyMap = {
        1: '代理商',
        2: '业主',
        3: '维保单位',
        4: '监管单位'
    }
    return nettyMap[status] || '异常'
}

// 时间格式化过滤器
// 扩展 formatTime
export const formatTime = (timestamp, format = 'default') => {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    // 日期有效性校验
    if (isNaN(date.getTime())) return ''

    const formats = {
        date: 'yyyy-MM-dd',
        time: 'HH:mm:ss',
        default: 'yyyy-MM-dd HH:mm:ss'
    }

    const pattern = formats[format] || format

    return pattern
        .replace('yyyy', date.getFullYear())
        .replace('MM', String(date.getMonth() + 1).padStart(2, '0'))
        .replace('dd', String(date.getDate()).padStart(2, '0'))
        .replace('HH', String(date.getHours()).padStart(2, '0'))
        .replace('mm', String(date.getMinutes()).padStart(2, '0'))
        .replace('ss', String(date.getSeconds()).padStart(2, '0'))
}



// 默认导出所有过滤器
export default {
    statusType,
    statusText,
    formatTime,
    productNettype,
    productFormat,
    productType,
    productAuth,
    productStatus,
    customerType
}